"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicalBusResultMetadataSchema = exports.LogicalBusValidationErrorSchema = exports.LogicalBusValidationErrorSeveritySchema = exports.LogicalBusValidationErrorSeverity = exports.LogicalBusValidationErrorTypeSchema = exports.LogicalBusValidationErrorType = exports.LogicalBusInstanceMetadataSchema = exports.LogicalBusValidationResultKey = exports.LogicalBusValidationRequirementTypeId = void 0;
const zod_1 = require("zod");
exports.LogicalBusValidationRequirementTypeId = 'LogicalBus';
exports.LogicalBusValidationResultKey = 'LogicalBusValidationResult';
exports.LogicalBusInstanceMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.LogicalBusValidationResultKey),
    busName: zod_1.z.string(),
    functionClass: zod_1.z.string(),
    components: zod_1.z.array(zod_1.z.object({
        moduleRef: zod_1.z.string(),
        moduleLocalFunctionName: zod_1.z.string(),
        displayProperties: zod_1.z.array(zod_1.z.object({
            type: zod_1.z.string(),
            value: zod_1.z.string(),
            moduleSignal: zod_1.z.string().nullish(),
        })),
    })),
    connections: zod_1.z.array(zod_1.z.object({
        functionSignal: zod_1.z.string(),
        net: zod_1.z.string(),
        moduleSignalId: zod_1.z.string(),
        moduleRef: zod_1.z.string(),
    })),
});
var LogicalBusValidationErrorType;
(function (LogicalBusValidationErrorType) {
    LogicalBusValidationErrorType["VALID_CONNECTIONS"] = "LogicalBus.ValidConnections";
    LogicalBusValidationErrorType["NO_CONNECT"] = "LogicalBus.NoConnect";
    LogicalBusValidationErrorType["UNSUPPORTED_FUNCTION"] = "LogicalBus.UnsupportedFunction";
    LogicalBusValidationErrorType["VALID_ADDRESSES"] = "LogicalBus.ValidAddresses";
    LogicalBusValidationErrorType["ADDRESS_CONTENTION"] = "LogicalBus.AddressContention";
    LogicalBusValidationErrorType["UNADDRESSED"] = "LogicalBus.Unaddressed";
    LogicalBusValidationErrorType["NET_NAME_CONFLICT"] = "Other.Warning.NetNameConflict";
})(LogicalBusValidationErrorType || (exports.LogicalBusValidationErrorType = LogicalBusValidationErrorType = {}));
exports.LogicalBusValidationErrorTypeSchema = zod_1.z.nativeEnum(LogicalBusValidationErrorType);
var LogicalBusValidationErrorSeverity;
(function (LogicalBusValidationErrorSeverity) {
    LogicalBusValidationErrorSeverity["PASS"] = "Pass";
    LogicalBusValidationErrorSeverity["FAIL"] = "Fail";
    LogicalBusValidationErrorSeverity["WARNING"] = "Warning";
})(LogicalBusValidationErrorSeverity || (exports.LogicalBusValidationErrorSeverity = LogicalBusValidationErrorSeverity = {}));
exports.LogicalBusValidationErrorSeveritySchema = zod_1.z.nativeEnum(LogicalBusValidationErrorSeverity);
exports.LogicalBusValidationErrorSchema = zod_1.z.object({
    errorType: exports.LogicalBusValidationErrorTypeSchema,
    severity: exports.LogicalBusValidationErrorSeveritySchema,
    message: zod_1.z.string(),
    moduleRef: zod_1.z.string().nullish(),
});
exports.LogicalBusResultMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.LogicalBusValidationResultKey),
    busValidations: zod_1.z.array(exports.LogicalBusValidationErrorSchema),
});
//# sourceMappingURL=LogicalBusValidationInstanceMetadata.js.map